import { newDateFromUTC, newDateToUTC } from '@bc-library/common'
import { leaveFormulas } from '@bc-library/leave'

// DATA RECEIVED FOM API (FROM UTC)

// GENERAL CASE : ARRAY OR SINGLE OBJECT
export const afterReceiving = (data:any) => {
  if(data && Array.isArray(data)){
    data = data.map((object:any) => {
     return afterReceivingOne(object);
   })
  }
  else if(data.docs && data.count && Array.isArray(data.docs)){
    data.docs = data.docs.map((object:any) => {
      return afterReceivingOne(object);
    })
  }
  else if(typeof data == 'object'){
    data = afterReceivingOne(data);
  }

  return data
};

// SINGLE OBJECT
export const afterReceivingOne = (object:any) => {
  if(typeof object == 'object'){
    if (object.initialBalances !== undefined && object.initialBalances !== null) {
        for (var i = 0; i < object.initialBalances.length; i++) {
            if (object.initialBalances[i].resourceId !== undefined && object.initialBalances[i].resourceId !== null) {
                for (var j = 0; j < object.initialBalances[i].leavePeriods.length; j++) {
                    object.initialBalances[i].leavePeriods[j].startDate = newDateFromUTC(object.initialBalances[i].leavePeriods[j].startDate, object.initialBalances[i].leavePeriods[j].startDate)
                };

            };
        };
    };
    if(object.formula !== undefined && Number.isInteger(object.formula)){
      object.formulaPopulated = leaveFormulas.find(formula => formula._id === object.formula) || null;
    }
  }
  return object;
}

// OBJECT FIELDS




// DATA TO BE SENT TO API (TO UTC)

// GENERAL CASE : ARRAY OR SINGLE OBJECT
export const beforeSending = (data:any) => {
  if(data && Array.isArray(data)){
    data = data.map((object:any) => {
      return beforeSendingOne(object);
    })
  }
  else if(typeof data == 'object'){
    data = beforeSendingOne(data);
  }
  return data;
};

// SINGLE OBJECT
export const beforeSendingOne = (object:any) => {
  if(typeof object == 'object'){
    if (object.initialBalances !== undefined && object.initialBalances !== null) {
        for (var i = 0; i < object.initialBalances.length; i++) {
            if (object.initialBalances[i].resourceId !== undefined && object.initialBalances[i].resourceId !== null) {
                for (var j = 0; j < object.initialBalances[i].leavePeriods.length; j++) {
                    object.initialBalances[i].leavePeriods[j].startDate = newDateToUTC(object.initialBalances[i].leavePeriods[j].startDate, object.initialBalances[i].leavePeriods[j].startDate)
                };

            };
        };
    };
  }
  return object;
}

// OBJECT FIELDS




